import * as React from "react";
import { Tooltip, InteractionTag, InteractionTagPrimary, InteractionTagSecondary } from "@fluentui/react-components";

import CiTypeImage from "../../citypes/components/CiTypeImage";

const MAX_LABEL_LENGTH = 24;

const CisBar = ({ params = {}, editable = false, cis = [], onRemoveCi = null, ...props }) => {
  const getDisplayLabel = (ci) => {
    return ci.name || ci.sn || ci.id;
  };

  const renderCiTag = (ci, isNew = false) => {
    const displayLabel = getDisplayLabel(ci);
    let labelToShow;
    if (displayLabel.length > MAX_LABEL_LENGTH) {
      labelToShow = displayLabel.slice(0, MAX_LABEL_LENGTH) + "...";
    } else {
      labelToShow = displayLabel;
    }
    return (
      <InteractionTag {...props} key={isNew ? `new-${displayLabel}` : ci.public_id} shape="rounded" size="medium">
        <InteractionTagPrimary
          icon={
            <CiTypeImage
              ciType={{
                id: ci.type_id,
                public_id: ci.public_type_id,
                name: ci.type,
                public_icon_id: ci.public_icon_id,
              }}
              width={20}
              margin={2}
            />
          }
          style={{ cursor: "default" }}
          hasSecondaryAction={editable}
        >
          {displayLabel.length > MAX_LABEL_LENGTH ? (
            <Tooltip content={displayLabel} relationship="label">
              <span style={{ wordBreak: "break-all", maxWidth: 180, display: "inline-block" }}>{labelToShow}</span>
            </Tooltip>
          ) : (
            <span style={{ wordBreak: "break-all", maxWidth: 180, display: "inline-block" }}>{labelToShow}</span>
          )}
        </InteractionTagPrimary>
        {editable && <InteractionTagSecondary aria-label="remove" onClick={() => onRemoveCi?.(ci.public_id)} />}
      </InteractionTag>
    );
  };

  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", alignItems: "center" }}>
      {cis.map((ci) => renderCiTag(ci))}
    </div>
  );
};

CisBar.displayName = "CisBar";

export default CisBar;
